// Log central de analytics para depuração no navegador.
//
// - Eventos disparados: logados só quando o debug está ligado (dev sempre; em produção
//   sob demanda via localStorage['@ConexaoGAM:analyticsDebug'] === '1').
// - Erros de adapter: SEMPRE via console.warn (raros e importantes), em qualquer ambiente,
//   conforme a regra "erro de analytics nunca propaga — no máximo console.warn".
import { isGtmEnabled, isPixelEnabled, isClarityEnabled } from "./config";

const LS_KEY = "@ConexaoGAM:analyticsDebug";

export function isAnalyticsDebug() {
  try {
    if (process.env.NODE_ENV !== "production") return true; // dev sempre liga
    return window.localStorage.getItem(LS_KEY) === "1";
  } catch (e) {
    return false;
  }
}

export function logDispatch(meta, payload) {
  if (!isAnalyticsDebug()) return;

  const clarityAtivo = !!(meta.clarity && (meta.clarity.event || (meta.clarity.tags || []).length));
  const destinos = {
    gtm: isGtmEnabled(),
    pixel: meta.pixel ? isPixelEnabled() : "n/a",
    clarity: clarityAtivo ? isClarityEnabled() : "n/a",
  };

  const group = console.groupCollapsed || console.log;
  group.call(console, `%c[analytics] ${payload.event}`, "color:#7c3aed;font-weight:bold");
  console.log("payload:", payload);
  console.log("destinos:", destinos);
  if (console.groupEnd) console.groupEnd();
}

export function logAdapterError(adapter, payload, error) {
  console.warn(`[analytics] erro no adapter ${adapter} para "${payload?.event}":`, error);
}
